import { FloatingLabel, Form } from "react-bootstrap";
import ILargeFloatingTextFieldProps from "./ILargeFloatingTextFieldProps";
import { v4 as uuid } from "uuid";
import { IsValid, ValidationCssClass } from "../Validation";
import { useTranslation } from "react-i18next";
import { mergeStyles } from "@fluentui/merge-styles";
import styles from "../formFields.module.scss";

export default function LargeFloatingTextField(props: ILargeFloatingTextFieldProps) {
    const { t } = useTranslation();

    const validationMessage = props.validationMessage || t("general.provideValue");
    
    let validationCssClass = ValidationCssClass(props.validation);
    let isValid = IsValid(props.validation);

    const floatingLabelCssClass = mergeStyles("mb-3", props.required ? styles.required : null);

    return (
        <FloatingLabel  controlId={`txt-${uuid()}`}
                        label={props.label}
                        className={floatingLabelCssClass}>
            <Form.Control   as="textarea"
                            placeholder={props.placeholder}
                            className={validationCssClass}
                            style={{ height: `${props.height}px` }}
                            value={props.value}
                            isValid={isValid}
                            disabled={props.disabled}
                            required={props.required}
                            onChange={(e) => props.onChange(e.target.value)}
                            />
            {
                isValid === false &&
                <div className="text-danger">
                    {validationMessage}
                </div>
            }
        </FloatingLabel>
      );
}